import { render, staticRenderFns } from "./HealthCheck.vue?vue&type=template&id=317aa4c0&scoped=true"
import script from "./HealthCheck.vue?vue&type=script&lang=js"
export * from "./HealthCheck.vue?vue&type=script&lang=js"
import style0 from "./HealthCheck.vue?vue&type=style&index=0&id=317aa4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317aa4c0",
  null
  
)

export default component.exports